import { useTranslate } from '@refinedev/core';
import type { PublicationListOut } from '@/api/generated/schemas';
import { MOBILE_PLACEHOLDER } from '@/components/mobile_preview/constants';
import { useMobilePreview } from '@/components/mobile_preview/mobilePreviewContext';
import { PublicationCoverThumb } from '@/components/user_catalog/publications/PublicationCoverThumb';
import {
  formatAudioDuration,
  publicationFormats,
} from '@/components/user_catalog/publications/publicationFacts';

/** Shelf tile side in the app's feed. */
export const TILE_SIZE = 110;

interface HomePreviewShelfTileProps {
  /** Absent while the shelf loads — the tile draws its placeholder. */
  publication?: PublicationListOut;
}

export const HomePreviewShelfTile = ({
  publication,
}: HomePreviewShelfTileProps) => {
  const t = useTranslate();
  const { mobileTheme } = useMobilePreview();

  const meta = [
    ...publicationFormats(publication).map((format) =>
      t(`user_catalog.common.formats.${format}`)
    ),
    formatAudioDuration(publication?.audio?.duration_minutes),
  ]
    .filter(Boolean)
    .join(' • ');

  return (
    <div style={{ width: TILE_SIZE, flexShrink: 0 }}>
      <PublicationCoverThumb
        url={publication?.cover_url}
        size={TILE_SIZE}
        background={MOBILE_PLACEHOLDER[mobileTheme]}
        borderRadius={8}
      />
      <div
        style={{
          marginTop: 6,
          fontSize: 12,
          lineHeight: 1.3,
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        {publication?.title ?? ''}
      </div>
      {meta && (
        <div style={{ fontSize: 11, opacity: 0.6, marginTop: 2 }}>{meta}</div>
      )}
    </div>
  );
};
